import prodConfig from './prod';
import devConfig from './dev';

export interface Config {
  readonly REACTION_TIMER: number;
  readonly SCREEN_SHARE_FPS: number;
  readonly MOUSE_SHARE_FPS: number;
  readonly SENTRY_DSN?: string;
  readonly SOCKET_BASE_URL: string;
  readonly BASE_URL: string;
  readonly API_BASE_URL: string;
  readonly MIN_CHROME_BROWSER: number;
  readonly VERSION: string;
  readonly COMMIT: string;
  readonly DEBUG: boolean;
  readonly APP_ENV: string;
  readonly GOOGLE_OAUTH_CLIENT_ID: string;
  readonly WHATSAPP_NUMBER: string;
  readonly SUPPORT_PHONE_NUMBER: string;
  readonly SALES_PHONE_NUMBER: string;
  readonly GTM_ID?: string;
  readonly GRADES: Array<{ label: string; value: string }>;
  readonly MIXPANEL_TOKEN: string;
  readonly DATA_PACKET_SIZE: number;
  readonly SUPPORT_EMAIL: string;
  readonly GOOGLE_BUSINESS_LINK: string;
  readonly BOT_USERNAME: string;
  readonly FIREBASE_CONFIG: object;
  readonly DATETIME_FORMAT: string;
  readonly RECORDING_WEBHOOK_URL: string;
  readonly ADOBE_PDF_EMBED_KEY: string;
  readonly SHOW_STUDENT_CAMERA_CONTROLS: boolean;
}

const defaultConfig: Config = {
  REACTION_TIMER: 2,
  SCREEN_SHARE_FPS: 12,
  MOUSE_SHARE_FPS: 18,
  BASE_URL: '',
  API_BASE_URL: '',
  SOCKET_BASE_URL: '',
  MIN_CHROME_BROWSER: 78,
  VERSION: 'unknown',
  COMMIT: 'unknown',
  DEBUG: false,
  APP_ENV: 'unknown',
  GOOGLE_OAUTH_CLIENT_ID: '',
  WHATSAPP_NUMBER: '+91 91509 33505',
  SUPPORT_PHONE_NUMBER: '+91 91509 33505',
  SALES_PHONE_NUMBER: '+91 82828 24825',
  GOOGLE_BUSINESS_LINK: 'https://g.page/r/CT-tfrrSuUwJEAg/review',
  GRADES: [
    { label: '3rd', value: '3' },
    { label: '4th', value: '4' },
    { label: '5th', value: '5' },
    { label: '6th', value: '6' },
    { label: '7th', value: '7' },
    { label: '8th', value: '8' },
    { label: '9th', value: '9' },
    { label: '10th', value: '10' },
    { label: 'Others', value: 'others' },
  ],
  MIXPANEL_TOKEN: '',
  DATA_PACKET_SIZE: 15000,
  SUPPORT_EMAIL: 'support@stayq.com',
  BOT_USERNAME: 'UwFi7B2WVTV-wHRd9GB-4VQ',
  FIREBASE_CONFIG: {},
  DATETIME_FORMAT: 'YYYY-MM-DDTHH:mm:ssZZ',
  RECORDING_WEBHOOK_URL: '',
  ADOBE_PDF_EMBED_KEY: '',
  SHOW_STUDENT_CAMERA_CONTROLS: false,
};

var config: Config = defaultConfig;
const isProdLike =
  process.env.NODE_ENV === 'production' &&
  process.env.REACT_APP_ENV !== 'staging'; //this is set by cloudflare for staging
const isMockMode = process.env.REACT_APP_MOCK === 'true';

if (isMockMode) {
  // `react-scripts build` always forces NODE_ENV=production, so isProdLike
  // would otherwise be true here too. Mock builds must never inherit real
  // server URLs or third-party keys (Sentry/Mixpanel/GTM/Firebase/OAuth) —
  // MSW only intercepts /api/* traffic, nothing else is mocked.
  config = {
    ...defaultConfig,
    ...devConfig,
    VERSION: 'mock',
    COMMIT: 'mock',
    APP_ENV: 'mock',
    DEBUG: true,
    BASE_URL: `https://${window.location.host}`,
    // Root-relative so requests still hit the /api/ path MSW's handlers match,
    // without pointing at any real backend host.
    API_BASE_URL: '/api/',
    SOCKET_BASE_URL: '',
    SENTRY_DSN: undefined,
    MIXPANEL_TOKEN: '',
    GTM_ID: undefined,
    // src/utils/firebase.ts calls getDatabase(app) at module load, which throws
    // ("Can't determine Firebase Database URL") if databaseURL is missing —
    // blanking the coach dashboard / masterclass routes. Give it a parseable
    // but non-real URL so init succeeds without touching any real Firebase
    // project (realtime is already stubbed by the mock WebSocket).
    FIREBASE_CONFIG: { apiKey: 'mock', projectId: 'mock', appId: 'mock', databaseURL: 'https://mock.firebaseio.com' },
    GOOGLE_OAUTH_CLIENT_ID: '',
  };
} else if (isProdLike) {
  config = {
    ...defaultConfig,
    ...prodConfig,
    VERSION: process.env.REACT_APP_RELEASE_VERSION || 'untagged',
    COMMIT: process.env.REACT_APP_RELEASE_COMMIT || 'untagged',
    APP_ENV: process.env.REACT_APP_ENV || 'production',
  };
} else {
  config = {
    ...defaultConfig,
    ...devConfig,
    VERSION: 'development',
    COMMIT: 'development',
    APP_ENV: 'development',
    DEBUG: true,
  };
}

(window as any).SQCONFIG = config;

export default config;
